"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setDataToStorage = exports.getDataFromStorage = void 0;
var firefly_utilities_ts_1 = require("firefly-utilities-ts");
function getDataFromStorage(eventManagerKey, persistMethod, storageKey) {
    var method = (persistMethod === 'cookies') ? 'window' : persistMethod;
    return firefly_utilities_ts_1.PersistenceManager.get(eventManagerKey + storageKey, method);
}
exports.getDataFromStorage = getDataFromStorage;
function setDataToStorage(data, eventManagerKey, persistMethod, storageKey) {
    var method = (persistMethod === 'cookies') ? 'window' : persistMethod;
    firefly_utilities_ts_1.PersistenceManager.set(eventManagerKey + storageKey, data, method);
}
exports.setDataToStorage = setDataToStorage;
